import axios, { AxiosResponse } from "axios";
import { API_URL } from "../constants";
import { UserInfo } from "../contexts/UserInfoContext";
import { resolveAccessToken } from "./Auth";
import type { CompanionSettings } from "@common/domain/types";

export async function getCompanionSettings(userInfo: UserInfo | undefined, personaId: string): Promise<CompanionSettings | undefined> {
    let token: string | null = null;
    if (userInfo?.accessToken) {
        token = await resolveAccessToken(userInfo.accessToken);
        if (!token) throw new Error("SESSION_EXPIRED");
    }

    try {
        const response: AxiosResponse = await axios.get(
            `${API_URL}/companion-settings/${personaId}`,
            token
                ? { headers: { Authorization: `Bearer ${token}` } }
                : undefined
        );

        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function updateCompanionSettings(
	userInfo: UserInfo | undefined,
	personaId: string,
	updates: Partial<CompanionSettings>
) {
    const token = await resolveAccessToken(userInfo?.accessToken);
    if (token) {
        try {
            const response: AxiosResponse = await axios.put(
                `${API_URL}/companion-settings/${personaId}`,
                updates,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            return response.data;
        } catch (error) {
            throw error
        }
    } else return undefined;
}
